module.exports = __webpack_public_path__ + "img/project1@2x.a4f1112f.jpg";